export enum ProductType {
    Advertisement = "ADVERTISEMENT",
    CueSheet = "CUE SHEET",
    Product = "PRODUCT",
    Recording = "RECORDING",
    SetList = "SET LIST",
}